import { Progress } from './ui/progress';

const LoadingProgress = ({ progress, message, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-md p-3 animate-fadeIn">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-gray-700">
            {message || 'Caricamento...'}
          </span>
          <span className="text-sm font-bold text-red-600">
            {progress}%
          </span>
        </div>
        <Progress value={progress} className="h-2" />
      </div>
    </div>
  );
};

export default LoadingProgress;
